import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['dataset'],
  data () {
    return {
      gradients: []
    }
  },
  computed: {},
  methods: {
    prepareData (collection) {
      let ret = []
      for (let k in collection) {
        ret.push(collection[k].total_returns && collection[k].total_returns ? collection[k].total_returns : collection[k].total )
      }
      return ret
    },
    prepareDataSet (datasets) {
      return [{
        label: this.$options.filters.translate('sales_stats'),
        borderColor: '#1ACA1A',
        pointBackgroundColor: '#1ACA1A',
        borderWidth: 1,
        pointBorderColor: '#1ACA1A',
        data: this.prepareData(datasets.shippings)
      }, {
        label: this.$options.filters.translate('cancellations'),
        borderColor: '#fc2525',
        pointBackgroundColor: '#fc2525',
        borderWidth: 1,
        pointBorderColor: '#fc2525',
        data: this.prepareData(datasets.cancellations)
      }, {
        label: this.$options.filters.translate('returns'),
        borderColor: '#eace17',
        pointBackgroundColor: '#eace17',
        borderWidth: 1,
        pointBorderColor: '#eace17',
        data: this.prepareData(datasets.returns)
      }]
    },
    prepareLabels (collection) {
      let ret = []
      for (let k in collection) {
        ret.push(k)
      }
      return ret
    },
    getTooltipProper (item, type) {
      switch (type) {
        case 'Verkaufstatistik':
          return [
            'Verkäufe (' + item.total + '):',
            ` - Schuhe.de: ${item.channels.schuhede.total}`,
            ` - Zalando: ${item.channels.zalando.total}`,
            ` - eBay: ${item.channels.ebay.total}`,
            ` - Amazon: ${item.channels.amazon.total}`,
            ` - Mirapodo: ${item.channels.mirapodo.total}`,
            ` - Check24: ${item.channels.check24.total}`,
            ` - Spartoo: ${item.channels.spartoo.total}`,
            ` - Tamaris: ${item.channels.tamaris.total}`
          ]
        case 'Stornos':
          return [
            'Stornos (' + item.total + '):',
            ` - Schuhe.de: ${item.channels.schuhede.total}`,
            ` - Zalando: ${item.channels.zalando.total}`,
            ` - eBay: ${item.channels.ebay.total}`,
            ` - Amazon: ${item.channels.amazon.total}`,
            ` - Mirapodo: ${item.channels.mirapodo.total}`,
            ` - Check24: ${item.channels.check24.total}`,
            ` - Spartoo: ${item.channels.spartoo.total}`,
            ` - Tamaris: ${item.channels.tamaris.total}`
          ]
        default:
          return [
            'Retouren:',
            ' - Verkäufe: ' + item.total_shippings,
            ' - Retouren: ' + item.total_returns,
            ' - Retourenprozent: ' + this.$options.filters.percentage(item.total_percentage),
            '',
            `Schuhe.de: ${this.$options.filters.percentage(item.channels.schuhede.percentage)} (Verkäufe: ${item.channels.schuhede.shippings}, Retouren: ${item.channels.schuhede.returns})`,
            '',
            `Zalando: ${this.$options.filters.percentage(item.channels.zalando.percentage)} (Verkäufe: ${item.channels.zalando.shippings}, Retouren: ${item.channels.zalando.returns})`,
            '',
            `eBay: ${this.$options.filters.percentage(item.channels.ebay.percentage)} (Verkäufe: ${item.channels.ebay.shippings}, Retouren: ${item.channels.ebay.returns})`,
            '',
            `Amazon: ${this.$options.filters.percentage(item.channels.amazon.percentage)} (Verkäufe: ${item.channels.amazon.shippings}, Retouren: ${item.channels.amazon.returns})`,
            '',
            `Mirapodo: ${this.$options.filters.percentage(item.channels.mirapodo.percentage)} (Verkäufe: ${item.channels.mirapodo.shippings}, Retouren: ${item.channels.mirapodo.returns})`,
            '',
            `Check24: ${this.$options.filters.percentage(item.channels.check24.percentage)} (Verkäufe: ${item.channels.check24.shippings}, Retouren: ${item.channels.check24.returns})`,
            '',
            `Spartoo: ${this.$options.filters.percentage(item.channels.spartoo.percentage)} (Verkäufe: ${item.channels.spartoo.shippings}, Retouren: ${item.channels.spartoo.returns})`,
            '',
            `Tamaris: ${this.$options.filters.percentage(item.channels.tamaris.percentage)} (Verkäufe: ${item.channels.tamaris.shippings}, Retouren: ${item.channels.tamaris.returns})`
          ]
      }
    },
    getTooltips () {
      let ret = {
        displayColors: false,
        callbacks: {
          label: (tooltipItem, data) => {
            let i = tooltipItem.datasetIndex
            let item = i === 0 ? this.dataset.shippings[tooltipItem.xLabel] : i === 1 ? this.dataset.cancellations[tooltipItem.xLabel] : this.dataset.returns[tooltipItem.xLabel]
            return this.getTooltipProper(item, data.datasets[i].label)
          }
        }
      }
      return ret
    }
  },
  mounted () {
  },
  watch: {
    dataset () {
	    this.$data._chart && this.$data._chart.destroy()
      let self = this
      this.renderChart({
        labels: this.prepareLabels(this.dataset.shippings),
        datasets: this.prepareDataSet(this.dataset)
      }, {
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        title: {
          display: true,
          fontSize: 32,
          text: this.$options.filters.translate('monthly_sales_stats', self.$store.getters.language),
          fontStyle: 'bold',
          fontColor: '#FFFFFF'
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: this.getTooltips()})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/MultipleLineChart.js